<template>
  <navBack></navBack>
  <div class="page">
    <t-search :focus="true" v-model="searchValue" @change="doContentSearch" placeholder="客户姓名/手机号" />
    <div class="container">


      <template v-for="item in customerList" :key="item.id">


        <t-cell :title="item.name" :description="item.mobile" arrow note="选择" @click="doSelectCustomer(item)" link hover
          ext-class="weui-cells-title"></t-cell>
      </template>



    </div>
  </div>

  <t-dialog v-model:visible="confirmDialogVisible" close-on-overlay-click title="确认绑定此客户?" cancel-btn="取消"
    :confirm-btn="{ content: '确定', variant: 'base', theme: 'light' }" @confirm="doConfirmCustomer"
    @cancel="confirmDialogVisible = false">
  </t-dialog>
</template>

<script setup>
import { ref, getCurrentInstance } from 'vue'
// 假设您有相应的状态管理或全局属性访问方式
import { updateField } from '@/utils';
import { Toast } from 'tdesign-mobile-vue';
import { stateShop, stateCustomer } from '@/store';
import navBack  from '@/components/nav-back.vue'
const { proxy } = getCurrentInstance();
const app = proxy.$cloudbase;

const selectedCustomerId = ref('');
const confirmDialogVisible = ref(false);
// 定义响应式数据
const searchValue = ref('')
const customerList = ref([])
const doConfirmCustomer = async () => {

  confirmDialogVisible.value = false;
  await updateField(app, selectedCustomerId.value, 'my_customer', { unionid: stateCustomer.unionid, avatarUrl: stateCustomer.avatarUrl })

  Toast.success('绑定成功')

  stateCustomer._id=selectedCustomerId.value;
  proxy.$router.back()
}

const doSelectCustomer = async (item) => {


  selectedCustomerId.value = item._id;
  confirmDialogVisible.value = true;
}

// 模拟搜索功能（需根据实际后端API替换）
const doContentSearch = async (value) => {
  
 

  if (value.length < 2) return
  const db = app.database();
  let queryData = {

    status: 0,
    $or: [{
      name: {
        $regex: value
      }
    }, {
      mobile: {
        $regex: value
      }
    }]
  };
  queryData.shopId = stateShop._id;
  await db.collection("my_customer").where(queryData).
    field({ _id: true, name: true, mobile: true, sum: true, storeAmount: true, avatarUrl: true, zengAmount: true, lastConsumAt: true, totalConsumAmount: true })
    .get().then(res => {
      customerList.value = res.data;

    })


}
 

</script>

<style scoped>
/* 您可以根据需要添加样式 */
.page {
  /* 页面样式 */
  padding: 8vw;
}

.container {
  /* 容器样式 */
}

.recentCustomerTitle {
  /* 标题样式 */
}
</style>